import { render, staticRenderFns } from "./AppHeaderForRace.vue?vue&type=template&id=b7a6e86c&"
import script from "./AppHeaderForRace.vue?vue&type=script&lang=js&"
export * from "./AppHeaderForRace.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports